import { render, staticRenderFns } from "./BatalCetakList.vue?vue&type=template&id=b8410c2a&"
import script from "./BatalCetakList.vue?vue&type=script&lang=js&"
export * from "./BatalCetakList.vue?vue&type=script&lang=js&"
import style0 from "./BatalCetakList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports